"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
require("./index.scss");
const RegistrationCompletePopup = (props) => {
    const { closePopup } = props;
    return (react_1.default.createElement(Popup_1.default, { onClose: closePopup, showClose: true },
        react_1.default.createElement("div", { className: 'registration-complete-popup' },
            react_1.default.createElement("p", null, "The next step is verifying and processing your submission. To view the status of your submission, navigate to your profile by clicking the Back to Profile button."),
            react_1.default.createElement("p", null, "When verification is completed, you will be notified via email with next steps for your account. This usually take 1-3 business days."),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: closePopup }, "Back to Profile"))));
};
exports.default = RegistrationCompletePopup;
